module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-panel panel",
    style: (_vm.panelStyle)
  }, [_vm._l((_vm.rows), function(row) {
    return [_c('a', {
      staticClass: "panel-block is-clearfix",
      class: {
        'panel-block--has-tag': row.value && row.value.type === 'tags' && row.value.data.length > 0, 'panel-block--loading': row.loading
      },
      style: (_vm.panelBlockStyle),
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.rowClicked(row)
        }
      }
    }, [(row.key.iconClass) ? _c('span', {
      staticClass: "lxm-panel__icon panel-icon",
      class: row.key.iconClass
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "lxm-panel__left-text"
    }, [_vm._v(_vm._s(row.key.text))]), _vm._v(" "), (row.value) ? [_c('span', {
      staticClass: "lxm-panel__value is-pulled-right has-text-right",
      style: (_vm.spanStyle(row))
    }, [(row.value.type === 'tags') ? [_vm._l((row.value.data), function(tag) {
      return [_c('span', {
        staticClass: "lxm-panel__tag"
      }, [_c('lxm-tag', {
        attrs: {
          "color": tag.color,
          "text": tag.text,
          "to": tag.to
        }
      })], 1)]
    })] : (row.value.type === 'text' || row.value.data) ? [_vm._v("\n            " + _vm._s(row.value.data) + "\n            "), (row.value.arrow) ? _c('img', {
      staticClass: "lxm-panel__right-arrow",
      attrs: {
        "src": require("../../images/main/contact/panel-right-arrow.png")
      }
    }) : _vm._e()] : [_vm._v("\n            " + _vm._s(_vm.valueContent(row)) + "\n          ")]], 2)] : _vm._e()], 2)]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d75a253", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d75a253!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmPanel.vue
// module id = 863
// module chunks = 0